import { render } from "./ServiceImportModal.vue?vue&type=template&id=0969fb5c&scoped=true"
import script from "./ServiceImportModal.vue?vue&type=script&lang=js"
export * from "./ServiceImportModal.vue?vue&type=script&lang=js"

import "./ServiceImportModal.vue?vue&type=style&index=0&id=0969fb5c&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0969fb5c"]])

export default __exports__